"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZUsePasswordReset = exports.ZRequestPasswordReset = exports.ZProfileResponseSchema = exports.ZRegisterResponseSchema = exports.ZErrorResponseSchema = exports.ZLoginUserSchema = exports.ZRegisterUserSchema = void 0;
const zod_1 = require("zod");
exports.ZRegisterUserSchema = zod_1.z.object({
    agreedToMarketing: zod_1.z.boolean().optional(),
    appleUserId: zod_1.z.string().nullable().optional(),
    dateOfBirth: zod_1.z.string().nullable().optional(),
    emailAddress: zod_1.z.string().email(),
    firstName: zod_1.z.string(),
    facebookUserId: zod_1.z.string().nullable().optional(),
    googleUserId: zod_1.z.string().nullable().optional(),
    inviterId: zod_1.z.string().nullable().optional(),
    lastName: zod_1.z.string(),
    password: zod_1.z.string().nullable().optional(),
    phoneNumber: zod_1.z.string().nullable().optional(),
    utmParameters: zod_1.z.record(zod_1.z.string()).nullable().optional(),
    abTestVariants: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional().nullable(),
});
exports.ZLoginUserSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().min(6),
});
exports.ZErrorResponseSchema = zod_1.z.object({
    message: zod_1.z.string(),
});
exports.ZRegisterResponseSchema = zod_1.z.object({
    player: zod_1.z.object({
        id: zod_1.z.string(),
        emailAddress: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
        phoneNumber: zod_1.z.string().nullable(),
        referralId: zod_1.z.string(),
        status: zod_1.z.string(),
        role: zod_1.z.string(),
    }),
    token: zod_1.z.string(),
});
exports.ZProfileResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    emailAddress: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    phoneNumber: zod_1.z.string().nullable(),
    referralId: zod_1.z.string(),
    status: zod_1.z.string(),
    role: zod_1.z.string(),
    abtestVariants: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional().nullable(),
});
const ZUserSchema = zod_1.z.object({
    id: zod_1.z.string(),
    emailAddress: zod_1.z.string(),
    firstName: zod_1.z.string(),
    role: zod_1.z.string(),
});
exports.ZRequestPasswordReset = zod_1.z.object({
    emailAddress: zod_1.z.string(),
});
exports.ZUsePasswordReset = zod_1.z.object({
    resetToken: zod_1.z.string(),
    newPassword: zod_1.z.string(),
});
//# sourceMappingURL=models.js.map